/** Base para errores reconocibles del dominio Fiscal (UI puede mapear por `code`). */
export class FiscalDomainError extends Error {
  readonly code: string;

  constructor(code: string, message: string) {
    super(message);
    this.name = new.target.name;
    this.code = code;
    Object.setPrototypeOf(this, new.target.prototype);
  }
}

export class FiscalPadronError extends FiscalDomainError {
  constructor(message = 'Error al consultar padrón ARCA.', code = 'FISCAL_PADRON_ERROR') {
    super(code, message);
  }
}
